import { ReactNode } from "react"

import { Box } from "wealthmode-frontend/gluestack/ui"

import { AppHeader, AppSidebar } from "@/components/index"
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED, SidebarProvider, useSidebar } from "@/context"

function DefaultLayoutContent({ children }: { children: ReactNode }) {
  const { sidebarShow, sidebarUnfoldable } = useSidebar()

  const sidebarWidth = sidebarShow ? (sidebarUnfoldable ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED) : 0

  return (
    <Box className="h-screen overflow-hidden bg-background-primary flex">
      <AppSidebar />

      <Box
        className="flex flex-1 min-h-0 min-w-0 flex-col transition-all duration-300"
        style={{ marginLeft: sidebarWidth }}
      >
        <AppHeader />
        <Box className="flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden p-15 w-full">{children}</Box>
      </Box>
    </Box>
  )
}

const DefaultLayout = ({ children }: { children: ReactNode }) => {
  return (
    <SidebarProvider>
      <DefaultLayoutContent>{children}</DefaultLayoutContent>
    </SidebarProvider>
  )
}

export default DefaultLayout
